var __jsx = React.createElement;
import * as React from 'react';
import * as ds from '@bob/design-system';
import { useClipboard } from '../../hooks/useClipboard';
import { useSocialShare } from '../../hooks/useSocialShare';
export function SocialShare(_ref) {
  var _ref$column = _ref.column,
      column = _ref$column === void 0 ? false : _ref$column,
      _ref$buttonLabel = _ref.buttonLabel,
      buttonLabel = _ref$buttonLabel === void 0 ? 'Partager' : _ref$buttonLabel,
      url = _ref.url,
      title = _ref.title,
      text = _ref.text;

  var _useClipboard = useClipboard(4000),
      canCopy = _useClipboard.canCopy,
      copy = _useClipboard.copy,
      copyStatus = _useClipboard.copyStatus;

  var _useSocialShare = useSocialShare(),
      canNativelyShare = _useSocialShare.canNativelyShare,
      share = _useSocialShare.share;

  if (canNativelyShare && !column && ds.utils.browser.isMobile()) {
    return __jsx(ds.Button, {
      onClick: function onClick() {
        return share({
          url: url,
          title: title,
          text: text
        });
      }
    }, buttonLabel);
  }

  return __jsx(ds.SocialShare, {
    copyStatus: copyStatus,
    column: column,
    onShare: function onShare(socialMedia) {
      return socialMedia === 'share' ? canCopy && copy(url) : share({
        classic: column ? true : !canNativelyShare,
        socialMedia: socialMedia,
        title: title,
        text: text,
        url: url
      });
    }
  });
}